import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';

export type RouteWithData = Route & { data?: { hiddenForSearch?: boolean, forSpecificHp?: boolean }, children?: RouteWithData[] };

const routes: RouteWithData[] = [

  /** Root redirect page */
  {
    path: '',
    redirectTo: 'initiator-registration-page',
    pathMatch: 'full',
    title: 'Redirect pagina',
    data: {
      hiddenForSearch: true,
    }
  },

  /** Un authenticated pages */
  {
    path: '', loadComponent: () => import('./components/main/main.component').then(m => m.MainComponent),
    children: [
      {
        path: 'initiator-registration-page',
        loadComponent: () => import('./modules/route-modules/initialisation/initiator-registration/initiator-registration.component').then(m => m.InitiatorRegistrationComponent),
        title: 'Welkomstpagina Handelingsperspectief OV-knoop'
      },
      {
        path: 'request-access',
        loadComponent: () => import('./modules/route-modules/initialisation/initiator-access-request/initiator-access-request.component').then(m => m.InitiatorAccessRequestComponent),
        title: 'Registratie'
      },
      {
        path: 'hp/status',
        loadComponent: () => import('./modules/route-modules/hps/approve-hp/status-hp.component').then(m => m.StatusHpComponent),
        title: 'Status',
        data: {
          hiddenForSearch: true,
        }
      },
      {
        path: 'privacy',
        loadComponent: () => import('./modules/route-modules/privacy/privacy.component').then(m => m.PrivacyComponent),
        title: 'Privacyverklaring',
      },
      {
        path: 'accessibility',
        loadComponent: () => import('./modules/route-modules/accessibility/accessibility.component').then(m => m.AccessibilityComponent),
        title: 'Toegankelijkheidsverklaring',
      },
    ]
  },

  /** Authenticated pages */
  {
    path: '', loadComponent: () => import('./components/main/main.component').then(m => m.MainComponent),
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'landing-page',
        loadComponent: () => import('./modules/route-modules/landing-page/landing-page.component').then(m => m.LandingPageComponent),
        title: 'Handelingperspectief overzicht',
        data: {
          forSpecificHp: true,
        }
      },
      {
        path: 'stakeholders',
        loadComponent: () => import('./modules/route-modules/initialisation/stakeholders/stakeholders.component').then(m => m.StakeholdersComponent),
        title: 'Stakeholders',
        data: {
          forSpecificHp: true,
        }
      },
      {
        path: 'assign-items',
        loadComponent: () => import('./modules/route-modules/initialisation/assign-items/assign-items.component').then(m => m.AssignItemsComponent),
        title: 'Items en taken definiëren',
        data: {
          forSpecificHp: true,
        }
      },
      {
        path: 'initialisation',
        loadComponent: () => import('./modules/route-modules/initialisation/initialisation.component').then(m => m.InitialisationComponent),
        title: 'Instellingen',
        data: {
          forSpecificHp: true,
        }
      },
      {
        path: 'items/current/data',
        loadComponent: () => import('./modules/route-modules/items/items.component').then(m => m.ItemsComponent),
        title: 'Huidige situatie items',
        data: {
          forSpecificHp: true,
        }
      },
      {
        path: 'items/current/evaluate',
        loadComponent: () => import('./modules/route-modules/items/items.component').then(m => m.ItemsComponent),
        title: 'Huidige item evaluatie',
        data: {
          forSpecificHp: true,
        }
      },
      {
        path: 'items/future/data',
        loadComponent: () => import('./modules/route-modules/items/items.component').then(m => m.ItemsComponent),
        title: 'Toekomstige situatie items',
        data: {
          forSpecificHp: true,
        }
      },
      {
        path: 'items/future/evaluate',
        loadComponent: () => import('./modules/route-modules/items/items.component').then(m => m.ItemsComponent),
        title: 'Toekomstige item evaluatie',
        data: {
          forSpecificHp: true,
        }
      },
      {
        path: 'fill-item',
        loadComponent: () => import('./modules/route-modules/items/fill-item/fill-item.component').then(m => m.FillItemComponent),
        title: 'Item bewerken',
        data: {
          forSpecificHp: true,
          hiddenForSearch: true,
        }
      },
      {
        path: 'evaluate-item',
        loadComponent: () => import('./modules/route-modules/items/evaluate-items/evaluate-items.component').then(m => m.EvaluateItemsComponent),
        title: 'Item beoordelen',
        data: {
          forSpecificHp: true,
          hiddenForSearch: true,
        }
      },
      {
        path: 'hps',
        loadComponent: () => import('./modules/route-modules/hps/hps.component').then(m => m.HpsComponent),
        title: 'Kies Handelingsperspectief'
      },
      {
        path: 'results/current',
        loadComponent: () => import('./modules/route-modules/results/results-page/results-page.component').then(m => m.ResultsPageComponent),
        title: 'Resultaten huidige situatie',

        data: {
          forSpecificHp: true,
        }
      },
      {
        path: 'results/future',
        loadComponent: () => import('./modules/route-modules/results/results-page/results-page.component').then(m => m.ResultsPageComponent),
        title: 'Resultaten toekomstige situatie',
        data: {
          forSpecificHp: true,
        }
      },
      {
        path: 'spiderweb',
        loadComponent: () => import('./modules/route-modules/spiderweb/spiderweb.component').then(m => m.SpiderwebComponent),
        title: 'Spiderweb overzicht',
        data: {
          forSpecificHp: true,
        }
      }
    ]
  },

   /** Pages outside of the main component */
   {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
    title: 'Login',
    data: {
      hiddenForSearch: true,
    }
  },
  
  /** Redirect all unknown paths */
  { path: '**', redirectTo: 'initiator-registration-page', data: { hiddenForSearch: true } },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


